import React from 'react';

const SettingsHero = ({ activeTab, setActiveTab }) => {
  const tabs = ["Profile"];
  // const tabs = ["Profile", "Your Exams", "Account"];

  return (
    <div className="w-full font-inter text-left bg-white mb-4 md:mb-5">
      {/* <div className="pt-6 md:pt-8 px-4 md:px-8">
        <h1 className="text-[20px] md:text-[18px] font-[500] text-[#000000] mb-4 md:mb-5 tracking-tight">
          Profile
        </h1>
      </div> */}
      <div className="w-full h-[1px] bg-[#E0E0E0]"></div>
      <div className="px-4 md:px-8 mt-4 md:mt-6 overflow-x-auto no-scrollbar border-b border-[#33333380] border-transparent">
        <div className="flex gap-6 md:gap-10 min-w-max">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`pb-3 md:pb-4 text-[14px] md:text-[18px] font-[500] tracking-tight transition-all relative outline-none whitespace-nowrap ${activeTab === tab
                ? "text-[#4096F6]"
                : "text-[#000000] hover:text-[#333]"
                }`}
            >
              {tab}
              {activeTab === tab && (
                <div className="absolute bottom-0 left-0 w-full h-[2px] md:h-[2.5px] bg-[#4096F6]"></div>
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SettingsHero;